import { render } from "./FlatShare.vue?vue&type=template&id=714b58a6&scoped=true"
import script from "./FlatShare.vue?vue&type=script&lang=js"
export * from "./FlatShare.vue?vue&type=script&lang=js"

import "./FlatShare.vue?vue&type=style&index=0&id=714b58a6&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-714b58a6"]])

export default __exports__